import { html, css, unsafeCSS, PropertyValues } from 'lit';
import style from './Spinner.scss?inline';
import { customElementWithTag } from '../../utils/lit.util';
import { Component } from '../Component';

const DEBUG_VERBOSE: boolean = false;
export const HHDSSpinnerTagName: string = 'hhds-spinner';
const TAG_NAME: string = HHDSSpinnerTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

@customElementWithTag(TAG_NAME)
export class HHDSSpinner extends Component {
	static styles = css`
		${unsafeCSS(style)}
	`;

	protected override init(): void {
		DEBUG_VERBOSE && console.log(LOG_PREFIX, 'init()');
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && console.log(LOG_PREFIX, 'destroy()');
	}

	protected override firstUpdated(_changedProperties: PropertyValues): void {}

	protected override updated(changedProperties: PropertyValues): void {
		super.updated(changedProperties);
	}

	render() {
		return html`<div class="${TAG_NAME}__loading">
			<div class="${TAG_NAME}__spinner" aria-hidden="true"></div>
		</div>`;
	}
}
